/*
 * File: CoreUI-White.ts
 * File Created: 2023-12-13 10:10:45
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 09:28:11
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { RegisterTheme } from "@/../core/theme";
import {
    CoreUI as CoreUIBase,
    SidebarHeader,
    SidebarNav,
    SidebarNavTitle,
    SidebarNavDivider,
    SidebarNavItem,
} from "@valuis0429/vue-coreui-white";
import packageJson from "@/package.json";
import LanguageModal from "@/components/modals/language-modal/language-modal.vue";
import ChangePasswordModal from "@/components/modals/change-password-modal/change-password-modal.vue";
import { BaseComponent } from "@root/components";
import BaseTheme from "../layout";

@RegisterTheme("coreui", "w_VAL_Theme_White")
@Component({
    components: {
        CoreUIBase,
        SidebarHeader,
        SidebarNav,
        SidebarNavTitle,
        SidebarNavDivider,
        SidebarNavItem,
    },
    template: "#generic-theme-layout",
})
export class CoreUIWhite extends BaseTheme {}
export default CoreUIWhite;
